// ! This file was auto-generated from the hermes OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    cancelBuildEndpointV1ConversationsConversationIdBuildsBuildIdCancelPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversations, id: arg.conversationId }, { type: Tags.conversations, id: "LIST" }]
    },
    createBuildEndpointV1ConversationsConversationIdBuildsPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversations, id: arg.conversationId }, { type: Tags.conversations, id: "LIST" }]
    },
    createConversationEndpointV1ConversationsPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.conversations, id: "LIST" }]
    },
    createFeedbackEndpointV1ConversationsConversationIdFeedbackPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversations, id: arg.conversationId }, { type: Tags.conversations, id: "LIST" }]
    },
    createUploadEndpointV1ConversationsConversationIdUploadsPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversations, id: arg.conversationId }, { type: Tags.conversations, id: "LIST" }]
    },
    deleteConversationEndpointV1ConversationsConversationIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversations, id: arg.conversationId }, { type: Tags.conversations, id: "LIST" }]
    },
    getBuildEndpointV1ConversationsConversationIdBuildsBuildIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversations, id: arg.conversationId }]
    },
    getConversationEndpointV1ConversationsConversationIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversations, id: arg.conversationId }]
    },
    listConversationsEndpointV1ConversationsGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.conversations, id: "LIST" }]
    },
    listMessagesEndpointV1ConversationsConversationIdMessagesGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversations, id: arg.conversationId }]
    },
    listWorkflowBuildNotificationsEndpointV1WorkflowBuildNotificationsGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.notifications, id: "LIST" }]
    },
    postMessageEndpointV1ConversationsConversationIdMessagesPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.conversations, id: arg.conversationId }, { type: Tags.conversations, id: "LIST" }]
    },
    updateWorkflowBuildNotificationEndpointV1WorkflowBuildNotificationsBuildIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.notifications, id: arg.buildId }, { type: Tags.notifications, id: "LIST" }]
    }
} as const;
